<template>
  <v-form @submit="onSubmit">
    <input-form v-model="item.doc" v-if="item && item.doc"/>
    <v-btn color="amber" light class="mt-5" @click="onSubmit">SAVE</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import InputForm from "./TravelForm"
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserActivationEdit",
  components: {
    InputForm,
  },
  data() {
    return {
      item: {},
    };
  },
  props: {
    id: String
  },
  watch: {
    id(val) {
      this.load(val);
    },
  },
  mounted() {
    this.load(this.id);
  },
  methods: {
    load(id) {
      const ref = fb.activateExCollection.doc(id);
      ref.get().then((doc) => {
        if (doc.exists) {
          this.item = doc.data();
        } else {
          alert("No such document!");
        }
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      const updateRef = fb.activateExCollection.doc(this.id);
      updateRef
        .set(this.item)
        .then(() => {
          this.item = {};
          this.$emit('complete')
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>
